import React from "react";
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  Stack,
  Link,
} from "@chakra-ui/core";
import Logo from "../elements/Logo";

/** Menu for mobile screen. For now empty  */

const MobileMenu = ({
  btnRef,
  isOpen,
  onClose,
  currentSection,
  setCurrentSection,
}) => {
  return (
    <>
      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        finalFocusRef={btnRef}
        size="full"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>
            <Logo />
          </DrawerHeader>

          <DrawerBody>
            <Stack textDecoration="none" color="primary.500" textTransform="uppercase" spacing={2}>
              <Link
                color={currentSection === "orders" && "success.400"}
                fontWeight={currentSection === "orders" && "bold"}
                onClick={() => {setCurrentSection("orders"); onClose()}}
              >
                Orders
              </Link>
              <Link
                color={currentSection === "customers" && "success.400"}
                fontWeight={currentSection === "customers" && "bold"}
                onClick={() => {setCurrentSection("customers"); onClose()}}
              >
                Customers
              </Link>
              <Link
                color={currentSection === "payouts" && "success.400"}
                fontWeight={currentSection === "payouts" && "bold"}
                onClick={() => {setCurrentSection("payouts"); onClose()}}
              >
                Payout
              </Link>
            </Stack>
          </DrawerBody>

          <DrawerFooter></DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default MobileMenu;
